import * as Tooltip from "@radix-ui/react-tooltip";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { UserIcon } from "@/shared/icons";

type Props = {
  owner: string;
  className?: string;
};

export default function EstateVehicleOwner({ owner, className }: Props) {
  return (
    <Tooltip.Provider delayDuration={150}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            className={cn(
              "flex items-center justify-center size-6 bg-dark-700 rounded-md",
              "group hover:bg-accent-solid/20 transition-[background]",
              className,
            )}
          >
            <UserIcon
              size={12}
              className="text-white group-hover:text-accent-solid transition-[fill]"
            />
          </button>
        </Tooltip.Trigger>

        <Tooltip.Portal>
          <Tooltip.Content
            side="top"
            align="center"
            sideOffset={8}
            className={clsx(
              "z-50 rounded-md bg-dark-800/90",
              "px-2.5 py-1 shadow-lg backdrop-blur",
            )}
          >
            <div className="text-14 font-bold text-gray whitespace-nowrap">{owner}</div>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
